import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

export const setColorTheme = isOSOnDarkMode => {
  const stored = LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME) || 'mix';
  const useMix = stored === 'mix' || stored === 'auto';
  const selectedColorScheme = useMix ? 'mix' : stored;

  document.documentElement.classList.add('theme-switching');

  if (selectedColorScheme === 'dark' || selectedColorScheme === 'mix') {
    document.body.classList.add('dark');
    document.documentElement.classList.add('dark');
    document.documentElement.style.setProperty('color-scheme', 'dark');
  } else {
    document.body.classList.remove('dark');
    document.documentElement.classList.remove('dark');
    document.documentElement.style.setProperty('color-scheme', 'light');
  }

  if (selectedColorScheme === 'mix') {
    document.body.classList.add('theme-mix');
  } else {
    document.body.classList.remove('theme-mix');
  }

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      document.documentElement.classList.remove('theme-switching');
    });
  });
};
